import type { EditorActions } from '@atlaskit/editor-core';

import type { Item } from '../../types';

export type UseExtensionParametersAndActionsProps = {
	editorActions: EditorActions;
	localId: string;
};

export type UpdateField<TParameters> = Partial<TParameters>;
export type UpdateFormFieldForAllItemsType<TItemParameters> = (
	updatedField: UpdateField<TItemParameters>,
) => void;
export type UpdateMainFormFieldType<TExtensionParameters> = (
	updatedField: UpdateField<TExtensionParameters>,
	options?: { fieldsToRemove?: string[] },
) => void;

export type UpdateItemFormFieldType = (itemId: string, updatedField: UpdateField<Item>) => void;
export type AddItemType = () => void;
export type RemoveItemType = (itemId: string) => void;

export enum CONDITIONAL_FIELDS {
	IS_AVATAR_SHOWN = 'isAvatarShown',
	IS_PUBLISH_DATE_SHOWN = 'isPublishDateShown',
	IS_SOCIAL_STATS_SHOWN = 'isSocialStatsShown',
	IS_ICON_SHOWN = 'isIconShown',
	IS_LABEL_SHOWN = 'isLabelShown',
	IS_SEGMENTATION_SHOWN = 'isSegmentationShown',
	IS_DESCRIPTION_SHOWN = 'isDescriptionShown',
}

export type ConditionalFields = {
	[CONDITIONAL_FIELDS.IS_AVATAR_SHOWN]?: boolean;
	[CONDITIONAL_FIELDS.IS_DESCRIPTION_SHOWN]?: boolean;
	[CONDITIONAL_FIELDS.IS_LABEL_SHOWN]?: boolean;
	[CONDITIONAL_FIELDS.IS_PUBLISH_DATE_SHOWN]?: boolean;
	[CONDITIONAL_FIELDS.IS_SEGMENTATION_SHOWN]?: boolean;
};

export type ItemDimensions = {
	height?: number;
	maxHeight?: number;
	maxWidth: number;
	minHeight?: number;
	minWidth: number;
};
